import { render, staticRenderFns } from "./ButtonAppleStore.vue?vue&type=template&id=f1feba04&"
import script from "./ButtonAppleStore.vue?vue&type=script&lang=js&"
export * from "./ButtonAppleStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports